exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.error[data-v-8da31fc8]{color:#e41b1b}", ""]);

// exports
